




































import { Component, Prop, Mixins } from "vue-property-decorator";

// Mixins
import BillableEntitiesInjectorMixin from "@/mixins/billableEntitiesInjectorMixin";

@Component
export default class BillableEntitiesControl extends Mixins(
  BillableEntitiesInjectorMixin
) {
  // Props

  @Prop({ default: "is-bottom-right" })
  public position!: string;

  @Prop({ default: false })
  public isDisabled!: boolean;

  // Methods

  public createClientAddress() {
    this.$billableEntitiesMethods.manageClientAddress({
      config: {
        events: {
          success: async address => {
            await this.$billableEntitiesMethods.refreshAddresses();
            this.$bus.$emit("selectBillableEntity", address);
          }
        }
      }
    });
  }

  public createClientCompany() {
    this.$billableEntitiesMethods.manageClientCompany({
      config: {
        events: {
          success: async company => {
            await this.$billableEntitiesMethods.refreshCompanies();
            this.$bus.$emit("selectBillableEntity", company);
          }
        }
      }
    });
  }
}
